import actionTypes from "../actionTypes";
import queryString from "query-string";
import _cloneDeep from "lodash-es/cloneDeep";

const source = queryString.parse(window.location.search).source;

if (!window.localStorage.getItem("isHomeTourDone")) {
  window.localStorage.setItem("isHomeTourDone", false);
}

const initialState = {
  data: null,
  message: null,
  acceptanceData: null,
  cities: [],
  outlets: [],
  deliveryTimeSlots: [],
  cityDeliveryTimeSlots: {},
  designations: [],
  referralData: null,
  commercialBanners: [],
  exigencyBanners: [],
  config: null,
  promotionData: null,
  notifications: {
    list: [],
    nextPage: 1,
    hasMore: true,
    unseenCount: 0,
  },
  showAppInstallPrompt: ((!source || source !== "app") && !window.location.href.includes("zomato/onboarding") && window.outerWidth < 992),
  tour: {
    home: window.localStorage.getItem("isHomeTourDone") === "false" ? 1 : false,
    listing: 1,
    cart: 1
  },
  payLaterModalMessage: {
    optIn: {
      imageURL: "",
      backgroundImageURL: "",
      backgroundAnimationURL: "",
      heading: "",
      text: ""
    }
  },
  consumerRail: null,
  homeData: {
    exigencyBanners: [],
    rails: []
  }
};

function userReducer(state = initialState, action) {
  const payload = action.payload;
  switch (action.type) {
    case actionTypes.HOME_TOUR_BEGIN:
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      return {
        ...state,
        tour: {
          ...state.tour,
          home: action.step
        }
      };

    case actionTypes.NOTIFICATIONS_GET_STATUS_DONE:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          unseenCount: payload.unseenCount,
        },
      };

    case actionTypes.GET_REWARDS_DONE:
      return {
        ...state,
        rewards: action.rewards,
      };

    case actionTypes.NOTIFICATIONS_GET_BEGIN:
      if (payload.isFirstTime) {
        return {
          ...state,
          notifications: {
            ...state.notifications,
            list: [],
          },
        };
      } else {
        return state;
      }

    case actionTypes.NOTIFICATIONS_GET_DONE:
      {
        const list = payload.isFirstTime ?
          payload.notifications : [...state.notifications.list, ...payload.notifications];
        return {
          ...state,
          notifications: {
            ...state.notifications,
            list: list,
            nextPage: payload.isFirstTime ? 2 : state.notifications.nextPage + 1,
            hasMore: list.length < payload.totalCount,
          },
        };
      }

    case actionTypes.RESET_NOTIFICATION_COUNT:
      {
        return {
          ...state,
          notifications: {
            ...state.notifications,
            unseenCount: 0,
          },
        };
      }

    case actionTypes.REGISTER_STEP_THREE_DONE:
      return {
        ...state,
        promotionData: payload.promotionData,
      };

    case actionTypes.CONFIG_GET_DONE:
      return {
        ...state,
        config: payload,
      };

    case actionTypes.USER_GET_DATA_DONE:
      return {
        ...state,
        data: { ...state.data, ...action.data },
      };

    case actionTypes.CART_DELETE_DONE:
      return {
        ...state,
        data: {
          ...state.data,
          cartProductsCount: action.payload.cartCount,
        },
      };

    case actionTypes.CATALOG_SEARCH_PRODUCTS_FOR_BUYER_DONE:
      {
        if (action.updatedCartCount) {
          return {
            ...state,
            data: {
              ...state.data,
              cartProductsCount: action.updatedCartCount
            },
          };
        }
        return { ...state }
      }


    case actionTypes.CART_ADD_DONE:
      const customConsumerRail = _cloneDeep(state.consumerRail);
      if (action.productType === "forgetProduct") {
        customConsumerRail.Rails[0].Products = customConsumerRail.Rails[0].Products.filter((ele) => {
          if (ele.Id !== action.product.Id) {
            return true
          }
          return false
        })
      }
      return {
        ...state,
        data: {
          ...state.data,
          cartProductsCount: state.data.cartProductsCount + 1,
        },
        consumerRail: customConsumerRail
      };

    case actionTypes.SEND_REFERRAL_EMAIL_INVITE_DONE:
      return {
        ...state,
        message: action.data,
      };

    case actionTypes.ACCEPT_TNC_DONE:
      return {
        ...state,
        acceptanceData: action.data,
      };

    case actionTypes.CART_GET_DONE:
      return {
        ...state,
        data: {
          ...state.data,
          // cartProductsCount: action.orders.reduce((combined, current) => {
          //   return combined + current.Products.length;
          // }, 0),
          cartProductsCount: action.cartCount ? action.cartCount : 0,
        },
      };

    case actionTypes.CART_CLEAR_DONE:
      return {
        ...state,
        data: {
          ...state.data,
          cartProductsCount: 0,
        },
      };

    case actionTypes.GET_OVERDUE_DONE:
      return {
        ...state,
        overdue: action.data,
      };

    case actionTypes.GET_COMMERCIAL_BANNER_DONE:
      return {
        ...state,
        commercialBanners: action.data,
        exigencyBanners: action.exigencyBanners
      };
    
    case actionTypes.GET_FEATURE_TICKER_DONE:
      return {
        ...state,
        featureTickers: action.data,
      };

    case actionTypes.TESTIMONIALS_DONE:
      return {
        ...state,
        testimonials: action.testimonials,
      };

    case actionTypes.USER_GET_CITIES_DONE:
      return {
        ...state,
        cities: action.cities,
      };

    case actionTypes.OUTLET_SWITCH_DONE:
      return {
        ...state,
        outletSwitchId: action.outletSwitchId,
      };

    case actionTypes.USER_GET_DELIVERY_TIME_SLOTS_BEGIN:
      return {
        ...state,
        deliveryTimeSlots: [],
      };

    case actionTypes.USER_GET_DELIVERY_TIME_SLOTS_DONE:
      {
        if (action.storeCityBasedSLots) {
          return {
            ...state,
            cityDeliveryTimeSlots: { ...state.cityDeliveryTimeSlots, ...action.cityDeliveryTimeSlots },
          };
        }
        return {
          ...state,
          deliveryTimeSlots: action.deliveryTimeSlots,
        };
      }

    case actionTypes.USER_GET_DESIGNATIONS_DONE:
      return {
        ...state,
        designations: action.designations,
      };

    case actionTypes.USER_GET_OUTLETS_BEGIN:
      return {
        ...state,
        accounts: [],
      };

    case actionTypes.USER_GET_OUTLETS_DONE:
      return {
        ...state,
        accounts: action.accounts,
      };

    case actionTypes.USER_GET_OUTLETS_ONLY_BEGIN:
      return {
        ...state,
        outlets: [],
      };

    case actionTypes.USER_GET_OUTLETS_ONLY_DONE:
      return {
        ...state,
        outlets: action.outlets,
      };

    case actionTypes.USER_GET_REFERRAL_DONE:
      return {
        ...state,
        referralData: action.data,
      };

    case actionTypes.CLOSE_APP_INSTALL_PROMPT:
      return {
        ...state,
        showAppInstallPrompt: false,
      };
    case actionTypes.GET_POPUP_CHECKOUT_DONE:
    case actionTypes.GET_POPUP_HOME_DONE:  
    case actionTypes.GET_POPUP_DONE:
      return {
        ...state,
        popupData: action.data,
      };

    case actionTypes.GET_PAST_ORDERS_DONE:
      return {
        ...state,
        pastOrders: action.data,
      };

    case actionTypes.GET_APP_LINK_DONE:
      return {
        ...state,
        appLinks: action.applinks,
      };

    case actionTypes.PAY_LATER_UPDATE_DONE:
      return {
        ...state,
        payLaterModalMessage: {
          ...state.payLaterModalMessage,
          optIn: {
            ...state.payLaterModalMessage.optIn,
            imageURL: payload.imageURL,
            backgroundImageURL: payload.backgroundImageURL,
            backgroundAnimationURL: payload.backgroundAnimationURL,
            heading: payload.heading,
            text: payload.text
          }
        }
      }

    case actionTypes.SEMI_SERVICEABLE_DONE:
      return {
        ...state,
        semiServiceableData: {
          ...state.semiServiceableData,
          data: action.data,
          hasMore: action.hasNextPage,
          nextPage: action.isFirstTime ? 2 : state.semiServiceableData.nextPage + 1,
          isFirstTime: action.isFirstTime
        },

      };

    case actionTypes.GET_CONSUMER_RAIL_DONE:
      return {
        ...state,
        consumerRail: action.consumerRail
      }

    case actionTypes.GET_FAQ_DONE:
      return {
        ...state,
        FAQs: action.data
      }

    case actionTypes.GET_FAQ_ANSWER_DONE:
      return {
        ...state,
        FAQsAnswer: action.data
      }

    case actionTypes.SET_FAQ:
      return {
        ...state,
        FAQsQuestion: action.data
      }

    case actionTypes.RESET_FAQ:
      return {
        ...state,
        FAQsQuestion: null,
        FAQsAnswer: null
      }

    case actionTypes.GET_AUTH_OPTIONS_DONE:
      return {
        ...state,
        authOptions: action.data
      }
    
    case actionTypes.ADD_NPS_RATING_DONE:
      return {
        ...state,
        reasonData: action.data.Reasons
      }

    case actionTypes.GET_HOME_DONE:
      return {
        ...state,
        homeData: {
          ...state.homeData,
          exigencyBanners: action.payload.ExigencyBanner,
          rails: action.payload.Rails
        }
      }
    
    case actionTypes.MILESTONE_DETAILS_DONE: 
    return {
      ...state,
      milestoneData: action.payload
    }
    
    case actionTypes.MILESTONE_HISTORICAL_DETAILS_DONE: 
    return {
      ...state,
      milestoneHistoricalData: action.payload
    }
    
    case actionTypes.GET_ZOMATO_STATUS_DONE: 
    return {
      ...state,
      zomatoStatus: action.payload
    }

    case actionTypes.UPDATE_USER_PREFERENCE_DONE:
    let preferenceState = {
      ...state,
      userPreference: action.payload,
      data: {
        ...state.data,
        preferences: {
          ...state.data.preferences,
        }
      }
    }
    if (action.setInRedux){
      preferenceState.data.preferences[action.preferenceType]= action.payload[action.preferenceType];
    }

    return preferenceState; 

    case actionTypes.GET_COMMUNICATIONS_DONE: 
    return {
      ...state,
      commData: action.payload,
      overdue: action.payload,
    }

    case actionTypes.GET_COMMUNICATIONS_INIT:
      return {
        ...state,
        commData: action.payload,
        overdue: action.payload,
      } 
    
    default:
      return state;
  }
}

export default userReducer;
